import { atom } from "jotai";

// State for the filter change confirmation modal
export const isFilterChangeConfirmationModalOpenAtom = atom(false);

// State to store the pending filter change details
export const pendingFilterChangeAtom = atom<{
    type: "theme" | "subtheme";
    newValue: (string | null)[];
} | null>(null);
